/**
 * Time unit constants in milliseconds.
 *
 * Centralized so callers don't reinvent `60 * 60 * 1000` math at the use
 * site. Month and year values are calendar approximations (30 / 365 days)
 * — sufficient for "X months ago" buckets, not for precision arithmetic.
 */

export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;
export const MS_PER_WEEK = 7 * MS_PER_DAY;
/** Approximate (30 days). Use only for relative-time buckets. */
export const MS_PER_MONTH = 30 * MS_PER_DAY;
/** Approximate (365 days). Use only for relative-time buckets. */
export const MS_PER_YEAR = 365 * MS_PER_DAY;
